<template>
  <footer class="app-footer">
    <div class="app-footer__content">
      <p>
        &copy;&nbsp;{{ currentYear }}&nbsp;АКБ &laquo;Алмазэргиэнбанк&raquo; АО.
        Генеральная лицензия ЦБ&nbsp;РФ &#8470;&nbsp;2602 от&nbsp;08.06.2015
      </p>
    </div>
  </footer>
</template>

<script setup lang="ts">
const currentYear = new Date().getFullYear();
</script>

<style lang="scss" scoped>
.app-footer {
  padding: 0 16px;

  &__content {
    max-width: 1200px;
    margin: 60px auto;
    color: $gray-primary;
    font-size: 16px;
    line-height: 20px;

    @media (max-width: 767px) {
      font-size: 14px;
      line-height: 18px;
    }
  }
}
</style>
